import { LoadState } from "../../constants/enums";
import { IActionItem, IActionItemsState } from "./actionItem.types";

export const initialActionItem: IActionItem = {
  action_item_unique_id: 0,
  action_item_uuid: "",
  mobile_no: "",
  name: "",
  assigned_to_uuid: "",
  assigned_to_name: "",
  conversation_id: "",
  category_code: "",
  category_name: "",
  priority: "MEDIUM",
  description: "",
  item: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
};

export const initialActionItemState: IActionItemsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  actionItem: {
    data: initialActionItem,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
